<template>
  <div class="content">
    <TopNavigation :top-act="'5'"/>
    <div :class="this.$store.state.webNavigator=='pc'?'':'pan110'">
      <listTopImg :imgType="'4'"/>
      <div class="marginAuto">
        <div v-if="this.$store.state.webNavigator=='phone'" class="brandInfo-tlt">
          - 品牌资讯 -
        </div>
        <articlePage  :listType="informationType"
                      :titles="'品牌资讯'"
                      :classType="'A5'"
                      :active="types"
                      :key="keys"
                      :pageIndex="current"
                      @getTotal="getTotal"
                      :toLeveListPath="toLeveListPath"
        />
        <Pagination :total="total" :display="12" :currentPage="current" @pagechange="getPage" :key="pageKey"/>
      </div>
    </div>
    <FooterNavigation />
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import articlePage from '../listPage/articlePage/articlePage';
import listTopImg from '../../components/listTopImg/listTopImg';
import Pagination from '../../components/Pagiantion/Pagination';

export default {
  name: 'brandInfo',
  components: {TopNavigation, FooterNavigation, articlePage, listTopImg, Pagination, },
  title () {
    return {
      title: '脂玫乐资讯|脂玫乐新闻|脂玫乐减肥资讯-脂玫乐(谷医坊)',
      keywords: '脂玫乐资讯，减肥方法，脂玫乐新闻，脂玫乐团队介绍',
      description: '脂玫乐品牌资讯，主要包含脂玫乐公司新闻与公司动态。',
    };
  },
  data () {
    return {
      informationType: '',
      keys: 1,
      pageKey: 2,
      types: '0',
      // 分页数据
      total: 1,
      current: 1,
      toLeveListPath: 'brandInfo',
    };
  },
  watch: {
    $route () {//idtypepage
      this.current = parseInt(this.$route.params.html.split("-")[2]);
      this.informationType = this.$route.params.html.split("-")[0];
      this.types = this.$route.params.html.split("-")[1];
      this.keys += 1;
      this.pageKey += 1;
    },
  },
  methods: {
    getTotal (data) {
      this.total = data;
    },
    getPage (data) {
      this.$router.push({path: '/' + this.$route.path.split('/')[1] + '/' + this.$route.params.html.split("-")[0] + '-' + this.$route.params.html.split("-")[1] + '-' + data + '-' + this.$route.params.html.split("-")[3], });
    },
  },
  async asyncData ({store, route, app, }) {
  },
  mounted () {
    this.current = parseInt(this.$route.params.html.split("-")[2]);
    this.informationType = this.$route.params.html.split("-")[0];
    this.types = this.$route.params.html.split("-")[1];
    this.keys += 1;
    this.pageKey += 1;
  },
  beforeDestroy () {

  },
  computed: {},
  created () {
  },
  filters: {},
};
</script>

<style lang="less" scoped>
  @import url("../brandInfo/brandInfo.less");

</style>



// WEBPACK FOOTER //
// brandInfo.vue